export enum SurveyAccordionEvents {
  surveyAccordionBackButtonClicked = 'Survey Accordion Back Button Clicked',
  surveyAccordionCloseButtonClicked = 'Survey Accordion Close Button Clicked',
  surveyAccordionMaximizeIconClicked = 'Survey Accordion Maximize Icon Clicked',
  surveyAccordionMinimizeIconClicked = 'Survey Accordion Minimize Icon Clicked',
  surveyAccordionSectionTabClicked = 'Survey Accordion Section Tab Clicked',
  surveyAccordionSkipToSectionDropdownClicked = 'Survey Accordion Skip To Section Dropdown Clicked',
  surveySubmitButtonClicked = 'Survey Submit Button Clicked',
  surveyNextButtonClicked = 'Survey Next Button Clicked',
}
